/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Cta_PrimaryInputs */

const en_dr_room_cta_primary = /** @type {(inputs: Dr_Room_Cta_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See Design Room`)
};

const id_dr_room_cta_primary = /** @type {(inputs: Dr_Room_Cta_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Design Room`)
};

/**
* | output |
* | --- |
* | "See Design Room" |
*
* @param {Dr_Room_Cta_PrimaryInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_cta_primary = /** @type {((inputs?: Dr_Room_Cta_PrimaryInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Cta_PrimaryInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_cta_primary(inputs)
	return en_dr_room_cta_primary(inputs)
});